
import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  size = input<'small' | 'medium' | 'large'>('medium');
  fullscreen = input<boolean>(false);
}
